<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
           
            <v-card-title>
              <v-row>
                <v-col cols="4" md="4">
                  <v-text-field v-model="search" append-icon="mdi-magnify" label="Search By Outturn" single-line hide-details></v-text-field>
                </v-col>
                <v-col cols="8" class="text-right">
                  <h4> {{ records[0]?.documentUpload?.fileName }}</h4>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-data-table :loading="loading" v-model="selected" :headers="computedHeaders" :items="records"
                            item-key="id" show-select class="elevation-1" :search="search" :single-select="singleSelect">
                <template v-slot:top v-if="hasCanBeApprovedData(records) && $can('CAN_UPDATE_WARRANT')">
                  <v-btn color="primary" @click="markWarrant()" :disabled="submitting">
  <v-progress-circular v-if="submitting" indeterminate size="20"></v-progress-circular>
  <span v-else>MARK AS COLLECTED</span>
</v-btn>

                </template>
                <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
                  <v-simple-checkbox :ripple="false" color="green" :value="isSelected" 
                    @input="select($event)" v-if="!$can('CAN_UPDATE_WARRANT')" disabled class="d-none">
                  </v-simple-checkbox>
                  <v-simple-checkbox :ripple="false" color="green" :value="isSelected" v-else @input="select($event)">
                  </v-simple-checkbox>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" v-on="on" text icon class="actions">
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item 
                        @click="showEditDialog(item)">
                        <v-list-item-title> view more</v-list-item-title>
                      </v-list-item>
                     
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:item.dateUpdated="{ item }">
              {{ item.dateUpdated | prettyDate }}
            </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    
  
      <v-dialog v-model="confirmDialog" max-width="400">
        <v-card>
          <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">Records</v-card-title>
          <v-card-text class="primary--text">
            {{ confirmMessage }}
            <v-text-field name="comment" label="Comment" v-model="approverComment" :rules="commentRules" required></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="confirmDialog = false" class="font-weight-bold">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary" class="accent--text logoutbtn" @click="markWarrant()">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline accent--text">Collection Details</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>

                <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.firstName" label="Driver firstname" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.lastName" label="Driver lastname" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.driverId.idNumber" label="ID Number" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.vehicleType" label="Vehicle Type" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.registrationNumber" label="Registration Number" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="grnRecord.collectionDetailsId.vehicleId.vehicleDescription" label="Vehicle Description" readonly></v-text-field>
                </v-col>
              </v-row>
            </v-form>
         
          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="editDialog = false">Close</v-btn>
            
          </v-card-actions>
          
        </v-card>
      </v-dialog>
  
    
    </v-container>
  </template>
  <script>
   import axios from "axios";
    import config from "../../../config";
    import { mapState } from "vuex";
  export default {
    data() {
      return {
        submitting: false,
        search: '',  // Define search property to bind with v-text-field
        records: [],  // Ensure records is defined
        selected: [],
        loading: false,
        singleSelect: false,
        confirmDialog: false,
        confirmMessage: '',
        approverComment: '',
        commentRules: [(v) => !!v || 'Comment is required'],
        editDialog: false,
        action: '',
        // grnRecord: {},
        grnRecord: {
      collectionDetailsId: {
        driverId: {
          firstName: "",
          lastName: ""
        },
        vehicleId: {
         vehicleType: "",
          vehicleDescription: "",
          registrationNumber:""
        }
      }
    },
   
        valid: false,
        approve: false,
        paginationOptions: {
          page: 1,
          itemsPerPage: 10,
        },
        totalRecords: 0, // Total items for pagination
      };
    },
    computed: {
      computedHeaders() {
        return [
  
        { text: "OutturnNumber", value: "outTurn" },
            { text: "Mark", value: "marks" },
            { text: "Grade", value: "grade" },
            { text: "WarrantNumber", value: "warrantNumber" },
            { text: "Season", value: "season" },
            { text: "Sale", value: "saleNumber" },
            { text: "Number Of Bags", value: "numberOfBags" },
            { text: "Number Of Pockets", value: "numberOfPocket" },
            { text: "Total Weight", value: "weight" },
            { text: "Marketer", value: "marketerName" },
            { text: "Status", value: "status.statusName" },
            { text: "Date", value: "dateUpdated" },
            // { text: "Actions", value: "actions" },
  
        ];
      },
    },
    methods: {
        markWarrant() {
    
    this.processingRequest = true;
    this.showProgressBar = true;
    this.submitting = true; // Start loader
    const url = `${config.serverURI}/warrant/markcollected`;
    
    const selectedIds = this.selected.map((item) => item.id);
    // console.log("Selected item", selectedIds);

    // axios.post(url, this.selected)
    axios
      .post(url, { ids: selectedIds })
      
      .then((response) => {
        this.snackbar = true;
        this.createDriverDetailsLoader = false;
        this.message = response.data.message;
        this.snackbarColor = response.data.error ? "error" : "primary";
        this.selected = [];
        this.driver={};
      })
      .catch((error) => {
        this.message = error.response ? error.response.status : "Error";
        this.snackbarColor = "error";
        this.snackbar = true;
        this.driver={};
      })
      .finally(() => {
          this.submitting = false; // Start loader
        this.driver={};
        
        this.showProgressBar = false;
        this.processingRequest = false;
        this.getDataFromApi();
      });
  },
    
  
      getDataFromApi() {
      this.loading = true;
      const { page, itemsPerPage } = this.paginationOptions; // Correct variable usage
    
      const url = `${config.serverURI}/warrant/uncollected?page=${page - 1}&size=${itemsPerPage}`; // Page is usually 0-based
      axios
        .get(url)
        .then((response) => {
          const data = response.data;
          
          this.records = data.content; // Ensure API returns paginated data in `content`
          this.totalRecords = data.page.totalElements; // Assign total number of records, not pages
  
          console.log("Fetched warrants:", this.records);
        })
        .catch((error) => {
          this.message = error.response ? error.response.status : "Error";
          this.snackbar = true;
          this.snackbarColor = "error";
        })
        .finally(() => {
          this.loading = false;
        });
  },
  
          handleChange () {
              // Update deleteFlag to true if the checkbox is checked
              this.grnRecord.deleteFlag = true
          },
  
          confirmAction (action) {
              this.action = action
              this.confirmDialog = true
              this.recordsToApprove = this.action.includes('SELECTED') ? this.selected.filter(record => record.status)
                  : this.records.filter(record => record.status)
              this.confirmMessage = action + ' - ' + this.recordsToApprove.length + ' records'
          },
          hasGrnStatusIdData (item) {
              // Assuming item.status is the property containing status data
              // return this.records.filter(item => item.status !== null );
              return item.status && (item.status.statusName === 'HOLDING_STATUS' || item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL' ||
              item.status.statusName === 'PENDING_APPROVAL'
              )
              // return this.records.filter(item => item.status !== null);
          },
  
          hasGrnApproveWarehouseData (item) {
              // Assuming item.status is the property containing status data
              // return this.records.filter(item => item.status !== null );
              return item.status && (item.status.statusName === 'PENDING_WAREHOUSE_APPROVAL')
          },
  
          hasGrnApproveMillerData (item) {
              // Assuming item.status is the property containing status data
              // return this.records.filter(item => item.status !== null );
              return item.status && (item.status.statusName === 'REFERRED_TO_MILLER')
              // return this.records.filter(item => item.status !== null);
          },
  
          hasCanBeApprovedData (records) {
              return records.length > 0 
        // && records.some(record => record.status && (record.status.statusName === 'PENDING_APPROVAL'))
          },
  
          hasGrnStatus () {
              // Assuming item.status is the property containing status data
              // return this.records.filter(item => item.status !== null );
              return this.records.filter(item => item.status !== null)
          },
          showEditDialog (item) {
              this.grnRecord = item
              this.editDialog = true
              
          },
          
    
      approveRecords() {
    console.log("Action:", this.action);
  
    if (this.recordsToApprove.length === 0) {
      this.$store.dispatch("alert/displayAlert", {
        snackbar: true,
        color: "error",
        message: "No record selected for action " + this.action,
      });
      return;
    }
  
    const recordData = {
      action: this.action,
      comment: this.approverComment,
      records: this.recordsToApprove,
    };
  
    this.loading = true; // Optional: Show loading state
  
    axios
      .post(`${config.serverURI}/warrant/recallCollection`, recordData)
      .then((response) => {
        if (response.data.error === false) {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: 'primary',
            message: response.data.message,
          });
        } else {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: response.data.message,
          });
        }
  
        // this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
        this.getDataFromApi()
        this.selected = [];
        this.confirmDialog = false;
        this.recordsToApprove = [];
        this.approverComment = "";
        this.confirmMessage = "";
      })
      .catch((error) => {
        this.$store.dispatch("alert/displayAlert", {
          snackbar: true,
          color: "error",
          message: error.response?.data?.message || "Error occurred",
        });
      })
      .finally(() => {
        this.loading = false; // Optional: Hide loading state
      });
  },
          triggerEditRecord () {
              this.editRecord(this.grnRecord).then(response => {
                  if (response.data.error === false) {
                      this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
                  } else {
                      this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
                  }
                  this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
                  this.selected = []
                  this.editDialog = false
              }).catch(error => {
                  this.$store.dispatch('alert/displayAlert', {
                      snackbar: true,
                      color: 'error',
                      message: error.response.data ? error.response.data.message : 'Error ocurred'
                  })
                  this.editDialog = false
              })
          },
          triggerApproveRecord () {
              // this.millerApproveRecord(this.grnRecord).then(response => {
              this.editRecord(this.grnRecord).then(response => {
                  if (response.data.error === false) {
                      this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
                  } else {
                      this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
                  }
                  this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
                  this.selected = []
                  this.editDialog = false
              }).catch(error => {
                  this.$store.dispatch('alert/displayAlert', {
                      snackbar: true,
                      color: 'error',
                      message: error.response.data ? error.response.data.message : 'Error ocurred'
                  })
                  this.editDialog = false
              })
          }
      },
    mounted() {
      this.getDataFromApi(); // Fetch data on component mount
    },
  };
  </script>
  
  
  
    <style>
    </style>
    